import clsx from "clsx";

import { IPaymentProfile } from "models/HaulPay";
import styles from "./style.module.scss";

type PaymentProfileProps = {
  payment_profile: IPaymentProfile;
  selectPaymentProfile: VoidFunction;
};

export default function PaymentProfile({
  payment_profile,
  selectPaymentProfile
}: Readonly<PaymentProfileProps>) {
  return (
    <button
      key={payment_profile.id}
      type="button"
      onClick={selectPaymentProfile}
      className={styles.paymentProfileWrapper}>
      <p className="text-left">
        {payment_profile.company_name} <br />
        <br />
        {`${payment_profile.owner_name_first} ${payment_profile.owner_name_last}`} <br />
        <br />
        <span
          className={clsx(
            "uppercase",
            payment_profile.status === "approved" ? "text-success" : "text-primary"
          )}>
          {`${payment_profile.status} | ${payment_profile.is_connected ? "connected" : "not connected"} `}
        </span>
        <span className="text-error">
          {payment_profile.authority === "BROKER_AUTH" && "Co-Broker Agreement Required"}
          <br />
        </span>
        {payment_profile.company_mc !== "" && `Mc# ${payment_profile.company_mc} `}
        <br />
        {payment_profile.company_dot !== "" && `Dot# ${payment_profile.company_dot}`} <br />
        {payment_profile.owner_email}
      </p>
    </button>
  );
}
